import { UpdateTimeTrackingEntryInput } from 'dy-frontend-http-repository/lib/modules/TimeTacking/inputs';
import { TimeTrackingEntryResource } from 'dy-frontend-http-repository/lib/modules/TimeTacking/resources';
import { createApi } from 'effector';
import moment from 'moment';

import { $workReports } from './states';

// API to manage time tracking entries state locally
export const timeTrackingEntriesApi = createApi($workReports, {
    add: (store, payload: TimeTrackingEntryResource) => {
        if (!store) {
            // Time tracking entries were NOT fetched yet
            return store;
        }

        return { ...store, items: [payload, ...store.items] };
    },

    update: (store, payload: { id: ID; input: UpdateTimeTrackingEntryInput }) => {
        if (!store) {
            // Time tracking entries were NOT fetched yet
            return store;
        }

        // Copy items
        const copyItems = store.items.slice(0);

        // Find items
        const foundItem = copyItems.find((t) => t.id === payload.id);

        if (!foundItem) {
            // Could NOT find item with provided ID
            return store;
        }

        // Update item
        foundItem.duration_min = payload.input.duration_min;
        foundItem.comment = payload.input.comment;

        return { ...store, items: copyItems };
    },

    remove: (store, entryId: ID) => {
        if (!store) {
            // Time tracking entries were NOT fetched yet
            return store;
        }

        // Copy items
        const itemsCopy = store.items.slice(0);

        return { ...store, items: itemsCopy.filter((e) => e.id !== entryId) };
    },
});
